import {
    CAMPAIGNS_REQUESTED,
    CAMPAIGNS_SUCCEEDED,
    CAMPAIGNS_FAILED,
} from './constants';

export function campaignsRequested() {
    return {
        type: CAMPAIGNS_REQUESTED,
        campaignsLoading: true,
    };
}

export function campaignsSucceeded(campaigns) {
    return {
        type: CAMPAIGNS_SUCCEEDED,
        campaigns,
        campaignsLoading: false,
    };
}

export function campaignsFailed(error) {
    return {
        type: CAMPAIGNS_FAILED,
        error,
        campaignsLoading: false,
    };
}
